<template>
  <div>
    <div class="questions-bg">
        <img src="../../../assets/xt_nl.png">
        <p>很抱歉您没有通过答题...</p>
        <p>您需要重新完成答题才能进行后续流程哦</p>
        <p class="result" :class="precent==''?'hide':''">正确率：<span>{{precent}}</span></p>
        <p class="btn" @click="btnClick">重新答题</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Fail',
  props: {
    precent: String
  },
  methods: {
    btnClick (e) {
      this.$emit('refresh')
    }
  }
}
</script>
<style lang="scss" scoped>
.questions-bg{
  margin-top: 0.76rem;
  width: 95%;
  margin-left: 2.5%;
  background: #F7F7F7;
  border: 1px solid #EEEFF1;
  border-radius: 0.12rem;
  text-align: center;
  img{
      width: 1.6rem;
      height: 1.42rem;
      margin-top: 0.76rem;
  }
  p{
    width: 100%;
    font-size: 0.28rem;
    color: #19191A;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 0.48rem;
  }
  .result{
    margin-top: 0.82rem;
    span{
      color: #FF5714;
    }
  }
  .btn{
    width: 90%;
    height: 0.92rem;
    line-height: 0.92rem;
    margin:0.6rem 0 0.56rem 5%;
    font-size: 0.3rem;
    color:#FFFFFF;
    border-radius: 2px;
    background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit-answer/components/Fail.vue